import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingImage', 'LandingProgressLoader', 'LandingFooter'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'WALL PILATES FOR WEIGHT LOSS',
			size: 'large',
			uppercase: true,
		}),

		LandingSubtitle: (): LandingComponentsConfig['LandingSubtitle'] => ({
			title: 'Start your <b>body transformation</b>',
			uppercase: true,
		}),
		LandingImage: (): LandingComponentsConfig['LandingImage'] => {
			return {
				img: require('@/assets/landing/free-wall-pilates/female.png'),
				customStyles: {
					height: '42vh',
				},
			}
		},
		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
		}),
	},
}

export default schema
